// extracted by mini-css-extract-plugin
export default {"counter":"counter_counter__x1m0B","counter__btn":"counter_counter__btn__Xr2ah","counter__value":"counter_counter__value__vrpCx"};